import { Component, Input } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { rotateImageData } from "@dffedb/ui";
import { EntitetStatus } from "@dffedb/util";

@Component({
    selector: "note-bilag",
    templateUrl: "./note-bilag.component.html",
    styleUrls: ["./note-bilag.component.scss"]
})
export class NoteBilagComponent {
    @Input() public formGroup: UntypedFormGroup;

    public onRoterClick(): void {
        rotateImageData(this.formGroup.controls["url"].value).then((result: string) => {
            this.formGroup.controls["url"].setValue(result);
        });
    }

    public get slettet(): boolean {
        return this.formGroup.get("status").value === EntitetStatus.Slettet;
    }

    public set slettet(value: boolean) {
        const noteBilagId = this.formGroup.get("noteBilagId").value;
        const status = this.formGroup.get("status");
        if (value) {
            status.setValue(EntitetStatus.Slettet);
        } else if (noteBilagId) {
            status.setValue(EntitetStatus.Aendret);
        } else {
            status.setValue(EntitetStatus.Tilfoejet);
        }
        status.markAsDirty();
    }
}
